import { useEffect } from "react";

// Image imports
import slider1 from "../assets/images/ai.jpeg";
import slider2 from "../assets/images/ai3.jpg";
import slider4 from "../assets/images/ai2.jpeg";

// Icon imports
import icon1 from "../assets/images/icons/client-7.svg";
import icon2 from "../assets/images/icons/innovative-product.svg";
import icon3 from "../assets/images/icons/software.svg";
import trophy from "../assets/images/icons/trophy.svg";
import team2 from "../assets/images/icons/team-2.svg";
import quality1 from "../assets/images/icons/quality.svg";
import routeIcon from "../assets/images/icons/route.svg";
import soft_ver from "../assets/images/icons/soft_ver.svg";
import support from "../assets/images/icons/support.svg";
import years_test from "../assets/images/icons/years_test.svg";
import manual_test from "../assets/images/icons/manual_test.svg";
import test_off from "../assets/images/icons/test_off.svg";
import abtsvg1 from "../assets/images/icons/app-development.png";
import abtsvg2 from "../assets/images/icons/qa.png";
import abtsvg4 from "../assets/images/icons/service.svg";
import abtsvg5 from "../assets/images/icons/ai.svg";
import abtsvg6 from "../assets/images/icons/mobile_app.png";
import abtsvg8 from "../assets/images/icons/prod.png";
import muleSoft from "../assets/images/icons/api-integration.svg";
import support3 from "../assets/images/icons/support3.svg";
import iconhome1 from "../assets/images/icons/ai-svg.svg";
import iconhome2 from "../assets/images/icons/software-platform-computer.svg";
import iconhome3 from "../assets/images/icons/cloud-icon.svg";
import iconhome4 from "../assets/images/icons/quality-medal.svg";
import cubeimg from "../assets/images/icons/cube.svg";
import diamondimg from "../assets/images/icons/dimond.svg";
import feildService from "../assets/images/icons/service.svg";

// Missing image files - set to null until images are added
const ecomm4 = null; // TODO: Add Ecom2.jpeg
const ecomm5 = null; // TODO: Add Ecom3.jpeg
const handover = null; // TODO: Add Handshake.jpeg
const picktal = null; // TODO: Add picktalent.jpeg

// Placeholder constants for missing images (these need to be added to the project)
const fast1 = null; // TODO: Add fast1 image
const fast2 = null; // TODO: Add fast2 image
const digi1 = null; // TODO: Add digi1 image
const digi2 = null; // TODO: Add digi2 image
const crm1 = null; // TODO: Add crm1 image
const crm2 = null; // TODO: Add crm2 image
const cloud4 = null; // TODO: Add cloud4 image
const cloud5 = null; // TODO: Add cloud5 image
const cad3 = null; // TODO: Add cad3 image
const cad4 = null; // TODO: Add cad4 image
const cyber4 = null; // TODO: Add cyber4 image
const cyber6 = null; // TODO: Add cyber6 image
const tm1 = null; // TODO: Add tm1 image
const tm2 = null; // TODO: Add tm2 image
const tm3 = null; // TODO: Add tm3 image
const tm4 = null; // TODO: Add tm4 image
const tm5 = null; // TODO: Add tm5 image
const products1Ai = null; // TODO: Add products1Ai image
const products2codeing = null; // TODO: Add products2codeing image
const products3cloud = null; // TODO: Add products3cloud image
const products4quality = null; // TODO: Add products4quality image
const cad1 = null; // TODO: Add cad1 image
const qa1 = null; // TODO: Add qa1 image
const manageit = null; // TODO: Add manageit image
const itConsulting = null; // TODO: Add itConsulting image
const digi = null; // TODO: Add digi image
const crm = null; // TODO: Add crm image
const maven = null; // TODO: Add maven image
const jenkins = null; // TODO: Add jenkins image
const testNG = null; // TODO: Add testNG image
const jmeter = null; // TODO: Add jmeter image
const postman = null; // TODO: Add postman image
const marketing = null; // TODO: Add marketing image
const analytics = null; // TODO: Add analytics image
const commerce = null; // TODO: Add commerce image
const platform = null; // TODO: Add platform image
const communities = null; // TODO: Add communities image
const serviceimg = null; // TODO: Add serviceimg image
const salesImg = null; // TODO: Add salesImg image

const chooseUsData = [
  {
    title: "Clients",
    icon: icon1,
    content:
      "Our team of experts works closely with you to develop customized solutions that reach your clients and achieve your business goals. Our expertise in digital marketing and communication enables us to help you connect with your clients.",
  },
  {
    title: "Innovative",
    icon: icon2,
    content:
      "We specialize in innovative solutions that transform the way you do business. Our team of experts delivers creative and innovative solutions to help you stay ahead of the competition.",
  },
  {
    title: "Transform",
    icon: icon3,
    content:
      "We help modernize your business with cutting-edge software solutions that keep you ahead of the curve. We optimize your business with software solutions that improve productivity, reduce costs, and increase revenue.",
  },
];

export const CADSuccessData = [
  {
    title: "20+ Years’ experience",
    icon: trophy,
    content:
      "20+ years of expertise in design consulting, technical advisory, and web development, providing innovative solutions for success.",
  },
  {
    title: "Highly Skilled Team",
    icon: team2,
    content:
      "A proficient team of core web technology and UX/UI experts, backed by a dedicated Quality Assurance team.",
  },
  {
    title: "High-Quality Deliverables",
    icon: quality1,
    content:
      "Our expert team works collaboratively to deliver exceptional results that surpass client expectations.",
  },
  {
    title: "Full-Service Partner",
    icon: routeIcon,
    content:
      "Your trusted partner for application development, support, and innovative enhancements, ensuring long-term success.",
  },
];

export const DigitalSuccessData = [
  {
    title: "Tailored Digital Tools",
    icon: trophy,
    content:
      "We specialize in creating customized digital solutions designed to align with your business needs and goals.",
  },
  {
    title: "Proven Expertise",
    icon: team2,
    content:
      "With a history of successful implementations, we deliver reliable tools that drive efficiency and growth.",
  },
  {
    title: "Innovation-Driven Design",
    icon: quality1,
    content:
      "Our tools are built using cutting-edge technology to empower businesses with future-ready solutions.",
  },
  {
    title: "Focus on Quality",
    icon: routeIcon,
    content:
      "We ensure every digital tool we deliver meets the highest standards, optimizing functionality and performance.",
  },
];

const serviceCADData_3 = [
  {
    title: "10+ Years’ experience",
    icon: trophy,
    content:
      "10+ Years’ experience in providing Design Consulting, Technical Advisory, and Web Development Services.",
  },
  {
    title: "Strong Team",
    icon: team2,
    content:
      "A strong team of core Web Technologies and UX/UI experts, supported by a specialized Quality Assurance team.",
  },
  {
    title: "Quality Deliverables",
    icon: quality1,
    content:
      "Our multi-skilled team of experts works collaboratively to ensure quality deliverables to meet and exceed client expectations",
  },
  {
    title: "End-to-end partner",
    icon: routeIcon,
    content:
      "Your end-to-end partner for the application development, support and enhancements.",
  },
];

export const itConsultingPoints = [
  {
    title: "Expertise Across Industries",
    icon: trophy,
    content:
      "We bring deep industry-specific knowledge and experience to deliver tailored solutions that address unique business challenges.",
  },
  {
    title: "Proven Track Record",
    icon: team2,
    content:
      "Our successful projects with Fortune 500 companies consistently reflect our ability to deliver impactful results that drive long-term value and growth",
  },
  {
    title: "Innovative Solutions",
    icon: quality1,
    content:
      "By embracing the latest technologies and methodologies, we craft forward-thinking solutions that keep your business competitive.",
  },
  {
    title: "Commitment to Quality",
    icon: routeIcon,
    content:
      "We prioritize excellence in every phase, from planning to execution, ensuring your projects meet the highest standards of quality and performance.",
  },
];

export const AbountUsKeyPoints = [
  {
    title: "Expert-Led Innovation",
    icon: trophy,
    content:
      "At Briozon, we combine industry expertise with innovative thinking to deliver transformative solutions that drive business success.",
  },
  {
    title: "Tailored Solutions for You",
    icon: team2,
    content:
      "We provide customized, scalable solutions designed to meet the unique challenges of your business and industry.",
  },
  {
    title: "Commitment to Excellence",
    icon: quality1,
    content:
      "Our dedication to quality ensures that every project is executed with precision, efficiency, and a focus on long-term impact.",
  },
  {
    title: "Collaboration for Success",
    icon: routeIcon,
    content:
      "We believe in building strong, collaborative partnerships with our clients to foster growth and achieve shared goals.",
  },
];


export const TalentManagementkeyPoints = [
  {
    title: "10+ Years’ experience",
    icon: trophy,
    content:
      "With over 10 years of experience, we deliver talent management solutions that boost workforce performance and drive growth.",
  },
  {
    title: "Expert Talent Strategy",
    icon: team2,
    content:
      "We provide tailored talent management strategies to align with your business goals and drive success.",
  },
  {
    title: "Proven Success",
    icon: quality1,
    content:
      "Our track record of delivering impactful talent solutions speaks to our ability to enhance workforce performance.",
  },
  {
    title: "Continuous Support",
    icon: routeIcon,
    content:
      "We offer ongoing support to ensure seamless talent management, fostering long-term growth and retention.",
  },
];

export const IndustriesKeyheader = [
  {
    title: "20+ Years’ experience",
    icon: trophy,
    content:
      "With over 20 years of experience, we provide industry-specific solutions in design consulting, technical advisory, and web development.",
  },
  {
    title: "Industry Expertise",
    icon: team2,
    content:
      "With years of expertise, we provide tailored solutions across industries, specializing in design, technical advisory, and web development.",
  },
  {
    title: "Innovative Approach",
    icon: quality1,
    content:
      "We drive transformation with creative strategies and advanced technology. Our solutions are tailored to help businesses thrive and achieve lasting success.",
  },
  {
    title: "Proven Results",
    icon: routeIcon,
    content:
      "We deliver results that boost efficiency and ROI through impactful projects. Our solutions enhance performance and drive growth.",
  },
];
const servicesQualityAData_4 = [
  {
    title: "50 + Experienced QE&A Engineers",
    icon: trophy,
    content:
      "50 + experienced QE&A Engineers with working knowledge on both Web and Desktop applications.",
  },
  {
    title: "Certified Software Versions",
    icon: soft_ver,
    content:
      "Certified in the latest Pega and Salesforce versions along with experience in the latest testing technologies.",
  },
  {
    title: "BPM & CRM Spplications Support",
    icon: support,
    content: "Supporting both BPM and CRM applications.",
  },
  {
    title: "10+ years in testing",
    icon: years_test,
    content: "Vast experience of around 10+ years in testing domain.",
  },
  {
    title: "Manual & Automation testing",
    icon: manual_test,
    content: "Well-versed in both Manual and Automation testing.",
  },
  {
    title: "Testing accelerators offering",
    icon: test_off,
    content: "Testing accelerators offering to reduce E2E testing effort.",
  },
];

export const QAKeyPoints = [
  {
    title: "30 + Experienced QA Engineers",
    icon: trophy,
    content:
      "30 + experienced QE&A Engineers with working knowledge on both Web and Desktop applications.",
  },
  {
    title: "Certified Software Versions",
    icon: soft_ver,
    content:
      "Certified in the latest Pega and Salesforce versions along with experience in the latest testing technologies.",
  },
  {
    title: "Web Applications Support",
    icon: support,
    content: "Supporting both BPM and CRM applications.",
  },
  {
    title: "10+ years in testing",
    icon: years_test,
    content: "Vast experience of around 10+ years in testing domain.",
  },
  {
    title: "Manual & Automation testing",
    icon: manual_test,
    content: "Well-versed in both Manual and Automation testing.",
  },
  {
    title: "Testing accelerators offering",
    icon: test_off,
    content: "Testing accelerators offering to reduce E2E testing effort.",
  },
];


export const ManagedServiceKeyPoints = [
  {
    title: "Expert Solutions",
    icon: trophy,
    
  },
  {
    title: "Tailored Strategies",
    icon: soft_ver,
    
  },
  {
    title: "Proven Track Record",
    icon: support,
    content: "Supporting both BPM and CRM applications.",
  },
  {
    title: "Scalable Results",
    icon: years_test,
   
  },
  {
    title: "24/7 Support",
    icon: manual_test,
    
  },
  {
    title: "Innovative Approach",
    icon: test_off,
    
  },
];

export const aboutSpecializedIndata = [
  {
    title: "Custom App Development",
    icon: abtsvg1,
    
  },
  {
    title: "QA Automation",
    icon: abtsvg2,
    
  },
  {
    title: "Artificial Intelligence (AI)",
    icon: abtsvg5,
    
  },
  {
    title: "Managed Services",
    icon: abtsvg4,
   
  },

  {
    title: "Mobile App Development",
    icon: abtsvg6,
    
  },
  
  {
    title: "Production Support",
    icon: abtsvg8,
    
  },
];

export const serviceOfferingForProducts = [
  {
    title: "Tailored Solutions",
    icon: soft_ver,
    //description:
      //"Access four innovative products designed to accelerate your product development journey.",
  },
  {
    title: "End-to-End Support",
    icon: abtsvg1,
    //description:
      //"Get comprehensive guidance from concept to launch.",
  },
  {
    title: "Advanced Technologies",
    icon: muleSoft,
    //description:
     // "Utilize cutting-edge tools and frameworks integrated into our offerings.",
  },
  
  {
    title: "Scalability & Flexibility",
    icon: quality1,
    //description:
     // "Build solutions that adapt and grow with your business.",
  },
  {
    title: "Talent & Expertise",
    icon: abtsvg6,
    //description:
     // "Collaborate with our skilled team to efficiently bring your vision to life.",
  },
  {
    title: "Streamlined Processes",
    icon: support3,
    //description:
    //  "Save time and resources with proven methodologies and pre-built capabilities.",
  },
];

export const EcommAppCard = [
  {
    imageUrl: ecomm4,
    title: "Powering Your Business with Advanced E-Commerce",
    content:
      "Leading software development expertise powers our E-commerce app, which is built with cutting-edge technology to offer a seamless and secure shopping experience. Backed by a team of talented experts, it provides personalized recommendations, efficient inventory management, and secure payment integrations to enhance your business. With our skilled professionals driving innovation, your organization is equipped to grow and thrive in a competitive market.",
  },
  {
    imageUrl: ecomm5,
    title: "Elevate Your Store with Advanced E-Commerce Technology",
    content:
      "With a focus on innovation, we help you transform your e-commerce experience. Our platform supports everything from inventory management to secure payment gateways, ensuring a seamless operation for your business. Our team of experts is dedicated to delivering solutions that enhance customer satisfaction and business growth.",
  },
];

export const DigitalAppCard = [
  {
    imageUrl: ecomm4,
    title: "Engage and Grow Your Audience",
    content:
      "Leverage advanced strategies to connect with your target market through compelling content, social media outreach, and SEO-driven campaigns. We focus on driving meaningful engagement that fosters trust and loyalty.",
  },
  {
    imageUrl: ecomm5,
    title: "Data-Driven Marketing Excellence",
    content:
      "Our digital marketing solutions rely on analytics to optimize performance, refine strategies, and achieve measurable results. From campaign tracking to actionable insights, we ensure every effort is impactful.",
  },
];


export const EcommOfferings = [
  {
    title: "Seamless Shopping Experience",
    icon: soft_ver,
    description:
      "Provide your customers with an intuitive, easy-to-navigate app that enhances their shopping journey.",
  },
  {
    title: "Personalized Recommendations",
    icon: abtsvg1,
    description:
      "Leverage advanced algorithms to offer tailored product suggestions, boosting customer engagement and sales.",
  },
  {
    title: "Secure Payment Integration",
    icon: muleSoft,
    description:
      "Ensure safe and smooth transactions with robust, secure payment gateway options for your customers.",
  },
  {
    title: "Efficient Inventory Management",
    icon: routeIcon,
    description:
      "Keep track of stock, manage listings, and streamline your product catalog for greater operational efficiency.",
  },
  {
    title: "Scalable & Flexible",
    icon: quality1,
    description:
      "Easily scale your business with a flexible platform that adapts to your growing e-commerce needs.",
  },
  {
    title: "Enhanced Customer Engagement",
    icon: abtsvg6,
    description:
      "Build strong, lasting relationships with your customers through personalized notifications and offers.",
  },
  
];

export const serviceCADData_4 = [
  {
    title: "Transformation Planning",
    icon: soft_ver,
    description:
      "Work with you to know the objectives, conduct user research, plan the road map for transformation journey.",
  },
  {
    title: "Discovery & Architect",
    icon: abtsvg1,
    description:
      "Ideate with you to get all the possible information about the patch work, to come up with best fit design and solution.",
  },
  {
    title: "Design Consulting",
    icon: muleSoft,
    description:
      "Perform detailed design iterations with you, consider alternate solutions and select best fit for your user case.",
  },
  {
    title: "End to End Development",
    icon: routeIcon,
    description:
      "Follow best in class standards, guidelines to develop the application and deliver the quality code.",
  },
  {
    title: "Quality Assurance & Testing",
    icon: quality1,
    description:
      "Performs testing for all the designed scenarios to ensure that your product is of the highest possible quality.",
  },
  {
    title: "Version Upgrade & Migrations",
    icon: abtsvg6,
    description:
      "Upgradation of existing application from older version of Angular/React to latest, and also migrate the applications from one web technology to another.",
  },
  {
    title: "Application Support & Enhancements",
    icon: support3,
    description:
      "We are your partner in the journey, performs support and enhancements for the applications to address new requirements to compete the market and satisfied the user needs.",
  },
];



export const serviceITConsultingData = [
  {
    title: "Strategic Planning",
    icon: soft_ver,
    description:
      "Collaborate with you to align IT strategies with your business goals, ensuring a roadmap for sustainable growth.",
  },
  {
    title: "Technology Assessment",
    icon: abtsvg1,
    description:
      "Evaluate your current IT landscape to identify gaps, optimize resources, and propose effective solutions.",
  },
  {
    title: "Architecture Design",
    icon: muleSoft,
    description:
      "Create scalable, efficient, and secure IT architecture tailored to meet your unique business needs.",
  },
  {
    title: "Process Optimization",
    icon: routeIcon,
    description:
      "Streamline IT workflows and enhance efficiency through innovative technology and strategic recommendations.",
  },
  {
    title: "Change Management",
    icon: quality1,
    description:
      "Support your business in adapting to IT changes while minimizing disruptions and maximizing adoption.",
  },

  {
    title: "Ongoing Support",
    icon: support3,
    description:
      "Provide continuous IT consulting to adapt to evolving business needs and ensure long-term success.",
  },
];

export const serviceOfferingCAD = [
  {
    title: "Transformation & Discovery",
    icon: soft_ver,
    description: "We help identify business needs and create a strategic plan for technology transformation."
  },
  {
    title: "Discovery & Architect",
    icon: abtsvg1,
    description:
      "Our experts design scalable and efficient solutions tailored to your unique business requirements.",
  },
  {
    title: "QA & Testing",
    icon: muleSoft,
    description:
      "We ensure high-quality applications by rigorously testing and optimizing for performance and functionality.",
  },
  {
    title: "End to End Development",
    icon: routeIcon,
    description:
      "We provide comprehensive development services, from concept to deployment, ensuring seamless delivery.",
  },
  {
    title: "Upgrades & Migrations",
    icon: quality1,
    description:
      "We manage smooth upgrades and migrations, ensuring your applications stay current and efficient.",
  },
  {
    title: "Support & Enhancements",
    icon: abtsvg6,
    description:
      "Our ongoing support and enhancements keep your applications optimized and adaptable to future needs.",
  },

];


export function useDocumentTitle(title) {
  useEffect(() => {
    document.title = title;
  }, [title]);
}

const topSlideData = [
  {
    id: 1,
    imgUrl: slider1,
    content: {
      title: "AI Services",
      heading:
        "We lead in crafting innovative applications for today's dynamic digital AI landscape.",
      textContent:
        "Our AI consulting expertise delivers innovative solutions across diverse industries, providing tailored excellence in business solutions",
      buttonText: "Explore",
      buttonUrl: "/services",
      // buttonUrl: routes.products.index,
    },
  },
  {
    id: 2,
    imgUrl: slider4,
    content: {
      title: "Talent Management",
      heading:
        "Where talent evolves into leaders.",
      textContent:
        "Expert Tech Talent for a Global Market: We identify and place elite technology professionals who accelerate results.",
      buttonText: "Explore",
      buttonUrl: "/talentmanagement",
    },
  },
  {
    id: 3,
    imgUrl: slider2,
    content: {
      title: "Our Top Products",
      heading:
        "We turn ideas into impactful solutions, empowering your vision with innovation.",
      textContent:
        "With our unparalleled expertise and collaborative approach, we drive success in an ever-evolving landscape. Together, we shape the future you envision.",
      buttonText: "Explore",
      buttonUrl: "/products",
    },
  },
  {
    id: 4,
    imgUrl:
      "https://images.unsplash.com/photo-1615914143778-1a1a6e50c5dd?q=80&w=1468&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    content: {
      title: "Industries We Cover",
      heading:
        "We specialize in innovative solutions that transform the way you do business.",
      textContent:
        "Our team of experts delivers creative and innovative solutions to help you stay ahead of the competition.",
      buttonText: "Explore",
      buttonUrl: "/industries",
    },
  },
];

const talentManagementData_1 = [
  {
    imageUrl: ecomm4,
    title: "Pioneers in Managing Digital Talent for Tomorrow's Success.",
    content:
      "As a renowned IT staffing firm in the United States, we collaborate with a diverse range of industries. Our steadfast commitment to excellence guarantees the delivery of exceptional talent tailored to your specific requirements. We empower organizations to fulfill their strategic and operational ambitions. Together, we foster innovation and success in an ever-evolving environment. <br> <br>Our specialists analyze our clients' business challenges, market trends, and organizational culture to identify the perfect talent. With a focus on digital and emerging technologies, we source experts in specialized fields such as AI, Full Stack Development, Analytics, Cloud, SAP, SQL/Oracle, Business Intelligence, and Infrastructure.",
  },
  {
    imageUrl: ecomm5,
    title: "Pioneers in Managing Digital Talent for Tomorrow's Success.",
    content:
      "We support a diverse global clientele and excel at pinpointing niche talent across regions such as North America and APAC. Clients have access to the talent they require, wherever and whenever they need it. We support a diverse global clientele and excel at pinpointing niche talent across regions such as North America and APAC.<br> <br> Clients have access to the talent they require, wherever and whenever they need it. We support a diverse global clientele and excel at pinpointing niche talent across regions such as North America and APAC. clients have access to the talent they require, wherever and whenever they need it.",
  },
];

export const talentManagementkey_1 = [
  {
    imageUrl: handover,
    title: "Leading Digital Talent Solutions for Tomorrow’s Success",
    content:
      "As a trusted IT staffing firm, we partner with diverse industries to deliver top-tier talent that aligns with your business goals. Our focus on emerging technologies ensures that we provide specialized experts in fields such as AI, Cloud, Full Stack Development, and more, empowering your organization for future success.",
  },
  {
    imageUrl: picktal,
    title: "Global Talent Expertise for Digital Success",
    content:
      "We provide access to specialized talent across regions like North America and APAC, ensuring our clients receive the skills they need, wherever and whenever required. Our focus on digital and emerging technologies helps businesses connect with top-tier experts to drive innovation and success in a rapidly changing environment.",
  },
];
export const fastATSdata1 = [
  {
    imageUrl: fast1,
    title: "Transform Your Recruitment Process",
    content:
      "Automate tedious hiring tasks like resume sorting and interview scheduling. Manage candidates effortlessly with a centralized system. Focus on building meaningful connections, not repetitive processes.",
  },
  {
    imageUrl: fast2,
    title: "Streamlined Collaboration for Hiring Teams",
    content:
      "Enable real-time communication and shared feedback within your team. Track every step of the hiring process in one intuitive platform. Keep everyone aligned to make faster, smarter hiring decisions.",
  },
];
export const fastATSKeyPoint = [
  {
    imageUrl: fast1,
    title: "Transform Your Recruitment Process",
    content:
      "Automate tedious hiring tasks like resume sorting and interview scheduling. Manage candidates effortlessly with a centralized system. Focus on building meaningful connections, not repetitive processes.",
  },
  {
    imageUrl: fast2,
    title: "Streamlined Collaboration for Hiring Teams",
    content:
      "Enable real-time communication and shared feedback within your team. Track every step of the hiring process in one intuitive platform. Keep everyone aligned to make faster, smarter hiring decisions.",
  },
];
export const digitooldata1 = [
  {
    imageUrl: digi1,
    title: "Lorem ipsum",
    content:
      " Lorem ipsum dolor sit, amet consectetur adipisicing elit. Adipisci    odit repellat reprehenderit in officia! Fuga, tempora quam.    Dolores, deserunt nobis?Lorem ipsum dolor sit, amet consectetur    adipisicing elit. Adipisci odit repellat reprehenderit in officia!    Fuga, tempora quam. D consectetur adipisicing elit. Adipisci odit    repellat reprehenderit in officia! Fuga, tempora quam. Dolores,    deserunt nobis?Lorem ipsum dolor sit, amet consectetur adipisicing    elit. Adipisci odit repellat reprehenderit in officia! Fuga,   tempora quam. Dolores, deserunt nobis?Lorem ipsum dolor sit, ametconsecteturadipisicing elit. Adipisci odit repellat reprehenderitin officia! Fuga, tempora quam. Dolores, deserunt nobis?",
  },
  {
    imageUrl: digi2,
    title: "Lorem",
    content:
      "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Adipisci   Lorem ipsum dolor sit, amet consectetur adipisicing elit. Adipisci   Lorem ipsum dolor sit, amet consectetur adipisicing elit. Adipisci   Lorem ipsum dolor sit, amet consectetur adipisicing elit. Adipisci      odit repellat reprehenderit in officia! Fuga, tempora quam.    Dolores, deserunt nobis?Lorem ipsum dolor sit, amet consectetur    adipisicing elit. Adipisci odit repellat reprehenderit in officia!    Fuga, tempora quam. D consectetur adipisicing elit. Adipisci odit    repellat reprehenderit in officia! Fuga, tempora quam. Dolores,    deserunt nobis?Lorem ipsum dolor sit, amet consectetur adipisicing    elit. Adipisci odit repellat reprehenderit in officia! Fuga,   tempora quam. Dolores, deserunt nobis?Lorem ipsum dolor sit, ametconsecteturadipisicing elit. Adipisci odit repellat reprehenderitin officia! Fuga, tempora quam. Dolores, deserunt nobis?",
  },
];

export const digitoolKeypiont = [
  {
    imageUrl: digi1,
    title: "Advanced Digital Tool Solutions",
    content:
      "Our team provides tailored digital tool solutions designed to integrate seamlessly with your existing infrastructure. We focus on maximizing efficiency and ensuring your tools are perfectly aligned with your business objectives.",
  },
  {
    imageUrl: digi2,
    title: "Efficient Data Synchronization",
    content:
      "We specialize in synchronizing data across platforms to ensure consistency and reliability. With our expertise, your digital tools will work harmoniously, helping you streamline workflows and improve productivity.",
  },
];

export const crmdata1 = [
  {
    imageUrl: crm1,
    title: "Briozon helps teams to move work forward",
    content:
      "At Briozon we have put together a very robust CRM Practice with seasoned professionals. This allows us to offer help to organizations with CRM Consulting, providing experienced CRM resources, helping in building internal teams or indeed doing end-to-end project implementation, etc.",
  },
  {
    imageUrl: crm2,
    title: "Briozon Provides accelerated rollout for you",
    content:
      "Be it High volume or High Value, Briozon exactly understands key needs for its customers and provides the best solutions to solve business challenges. With Briozon it is easy to get started on Salesforce implementation journey, and it’s made even easier with consulting, implementation, and training offered by our experts",
  },
];

const talentManagementData_2 = [
  {
    title: "Contract to Hire",
    content:
      "Contract-to-hire allows you to bring on additional staff for a defined period, with the option to transition them to full-time roles. Operating across various industries, we offer contract-to-hire solutions for projects requiring immediate resource allocation, while also supporting your future growth. Our services help you assess the risks of direct hiring and evaluate whether a candidate is the right fit during the initial contract period.",
  },
  {
    title: "Permanent Staffing",
    content:
      "We dedicate time to understanding your business needs, industry skill sets, workforce market, and other pertinent details about the position to ensure we present the right candidate. Our recruitment experts utilize advanced search processes to identify, screen, and qualify candidates effectively. By streamlining the hiring process, we save you time and costs, ensuring you find talent that not only meets the job description but also aligns with your company culture, values, and long-term goals.",
  },
  {
    title: "Supplier Optimization",
    content:
      "With vast experience and a global footprint, we partner with multi-billion-dollar clients across the USA, Canada and India to achieve cost savings and minimize disruptions. We focus on optimizing tail spend, reducing supplier layers, and excelling in contract negotiation, compliance, and governance. Our Preferred Partner program, bolstered by governance, financial resources, and a legal team, promotes diversity spending and facilitates smooth geographical expansion. As a certified MBE, Briozon ensures compliance and acts as a trusted intermediary between you and your vendors",
  },
  {
    title: "Recruit, Develop, and Implement",
    content:
      "We provide a full suite of HTD solutions to assist you in sourcing, training, and deploying talent, whether you’re a small business or a large corporation. Our customized programs, which include accent-neutral, technical, and cultural fit training, create a seamless talent pipeline from entry-level to specialized positions. By leveraging access to diverse markets and collaborating with top institutions and industry leaders, we equip your workforce with advanced skills. We manage everything from background checks to payroll, ensuring a smooth experience while promoting diversity and facilitating your global expansion.",
  },
  {
    title: "Contract Talent Acquisition",
    content:
      "Our recruiting specialists have elevated the screening and hiring process for short-term projects to a new standard of efficiency. With our contract services, you can seamlessly fulfill temporary staffing needs across a diverse array of industries. Our dedicated team works in close partnership with you to ensure that your staffing requirements are expertly addressed for upcoming projects and seasonal demands, empowering you to maintain optimal staff levels through strategic contract hiring.",
  },
];
const serviceCADData_2 = [
  {
    title: "Lorem ipsum",
    content:
      " Lorem ipsum dolor sit, amet consectetur adipisicing elit. Adipisci  Lorem ipsum dolor sit, amet consectetur adipisicing elit. Adipisci  Lorem ipsum dolor sit, amet consectetur adipisicing elit. Adipisci   ",
  },
  {
    title: "Lorem",
    content:
      " Lorem ipsum dolor sit, amet consectetur adipisicing elit. Adipisci  Lorem ipsum dolor sit, amet consectetur adipisicing elit. Adipisci  Lorem ipsum dolor sit, amet consectetur adipisicing elit. Adipisci   ",
  },
  {
    title: "Lorem Heading ipsum",
    content:
      " Lorem ipsum dolor sit, amet consectetur adipisicing elit. amet consectetur adipisicing elit amet consectetur adipisicing elit Adipisci  Lorem ipsum dolor sit, amet consectetur adipisicing elit. Adipisci  Lorem ipsum dolor sit, amet consectetur adipisicing elit. Adipisci   ",
  },
];
const servicecloudData_1 = [
  {
    title: "Lorem ipsum",
    imageUrl: cloud5,
    content:
      "Expertise in API integration them. We have technical experts with deep integration them. We have technical experts with deep understanding of API protocols, data formats, and authentication methods to create seamless and efficient integrations.Expertise in API integration involves understanding the technical nuances of connecting disparate systems and translating data between them. We have technical experts with deep understanding of API protocols, data formats, and authentication methods to create seamless and efficient integrations.",
  },
  {
    title: "Lorem",
    imageUrl: cloud4,
    content:
      "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Adipisci  Lorem ipsum dolor sit, amet consectetur adipisicing elit. Adipisci  Lorem ipsum dolor sit, amet consectetur adipisicing elit. Adipisci       Lorem ipsum dolor sit, amet consectetur adipisicing elit. Adipisci  Lorem ipsum dolor sit, amet consectetur adipisicing elit. Adipisci  Lorem ipsum dolor sit, amet consectetur adipisicing elit. Adipisci    Lorem ipsum dolor sit, amet consectetur adipisicing elit. Adipisci  Lorem ipsum dolor sit, amet consectetur adipisicing elit. Adipisci  Lorem ipsum dolor sit, amet consectetur adipisicing elit. Adipisci       Lorem ipsum dolor sit, amet consectetur adipisicing elit. Adipisci  Lorem ipsum dolor sit, amet consectetur adipisicing elit. Adipisci  Lorem ipsum dolor sit, amet consectetur adipisicing elit. Adipisci",
  },
];
const serviceCADData_1 = [
  {
    title: "Lorem ipsum",
    imageUrl: cad3,
    content:
      "Expertise in API integration them. We have technical experts with deep integration them. We have technical experts with deep understanding of API protocols, data formats, and authentication methods to create seamless and efficient integrations.Expertise in API integration involves understanding the technical nuances of connecting disparate systems and translating data between them. We have technical experts with deep understanding of API protocols, data formats, and authentication methods to create seamless and efficient integrations.",
  },
  {
    title: "Lorem",
    imageUrl: cad4,
    content:
      "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Adipisci  Lorem ipsum dolor sit, amet consectetur adipisicing elit. Adipisci  Lorem ipsum dolor sit, amet consectetur adipisicing elit. Adipisci       Lorem ipsum dolor sit, amet consectetur adipisicing elit. Adipisci  Lorem ipsum dolor sit, amet consectetur adipisicing elit. Adipisci  Lorem ipsum dolor sit, amet consectetur adipisicing elit. Adipisci    Lorem ipsum dolor sit, amet consectetur adipisicing elit. Adipisci  Lorem ipsum dolor sit, amet consectetur adipisicing elit. Adipisci  Lorem ipsum dolor sit, amet consectetur adipisicing elit. Adipisci       Lorem ipsum dolor sit, amet consectetur adipisicing elit. Adipisci  Lorem ipsum dolor sit, amet consectetur adipisicing elit. Adipisci  Lorem ipsum dolor sit, amet consectetur adipisicing elit. Adipisci",
  },
];
const servicecyberData_1 = [
  {
    title: "Lorem ipsum",
    imageUrl: cyber4,
    content:
      "Expertise in API integration them. We have technical experts with deep integration them. We have technical experts with deep understanding of API protocols, data formats, and authentication methods to create seamless and efficient integrations.Expertise in API integration involves understanding the technical nuances of connecting disparate systems and translating data between them. We have technical experts with deep understanding of API protocols, data formats, and authentication methods to create seamless and efficient integrations.",
  },
  {
    title: "Lorem",
    imageUrl: cyber6,
    content:
      "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Adipisci  Lorem ipsum dolor sit, amet consectetur adipisicing elit. Adipisci  Lorem ipsum dolor sit, amet consectetur adipisicing elit. Adipisci       Lorem ipsum dolor sit, amet consectetur adipisicing elit. Adipisci  Lorem ipsum dolor sit, amet consectetur adipisicing elit. Adipisci  Lorem ipsum dolor sit, amet consectetur adipisicing elit. Adipisci    Lorem ipsum dolor sit, amet consectetur adipisicing elit. Adipisci  Lorem ipsum dolor sit, amet consectetur adipisicing elit. Adipisci  Lorem ipsum dolor sit, amet consectetur adipisicing elit. Adipisci       Lorem ipsum dolor sit, amet consectetur adipisicing elit. Adipisci  Lorem ipsum dolor sit, amet consectetur adipisicing elit. Adipisci  Lorem ipsum dolor sit, amet consectetur adipisicing elit. Adipisci",
  },
];
const productsSliderHomeData = (data) => {
  var routes = data.routes;
  return [
    {
      img: products1Ai,
      title: "AI & ML Implementation",
      icon: iconhome1,
      content:
        "AI and ML implementation empowers businesses with personalized marketing insights, leveraging customer data for targeted campaigns. Predictive maintenance anticipates equipment failures, reducing downtime and optimizing operational efficiency,and enhance productivity, resulting in increased efficiency and profitability. ",
      link: routes.services.businessintelligence,
    },
    {
      img: products2codeing,
      title: "Software Development",
      icon: iconhome2,
      content:
        "Involves creating unique software solutions tailored to the specific needs of a business or organization, allowing for greater flexibility, scalability, and functionality than off-the-shelf software. It can improve business processes, automate tasks, and enhance productivity, resulting in increased efficiency and profitability.",
      link: routes.services.mobileappdev,
    },
    {
      img: products3cloud,
      title: "Cloud Specialization",
      icon: iconhome3,
      content:
        "We focusing on a specific area or technology within the broader field of cloud computing. This can include specializing in a particular cloud platform that fits on customer needs, such as AWS, Azure, or GCP, or in a specific area of cloud computing, such as cloud security, cloud migration, cloud architecture, or cloud operations.",
      link: routes.services.cloudcomputing,
    },
    {
      img: products4quality,
      title: "Custom CRM",
      icon: iconhome4,
      content:
        "Streamline your workflow with our customizable CRM, designed to fit your unique business needs. Boost productivity, enhance customer relationships, and drive growth with our tailored CRM solution.Elevate your business with our bespoke CRM solution. From personalized customer interactions to seamless process automation, our custom CRM empowers you to unlock your full potential and achieve unparalleled success.",
      link: routes.products.customcrm,
    },
  ];
};

const talentMgmtData3 = (data) => {
  var routes = data.routes;
  return [
    {
      img: products1Ai,
      title: "Contract to Hire",
      icon: iconhome1,
      content:
        "Contract-to-hire allows you to bring on additional staff for a defined period, with the option to transition them to full-time roles. Operating across various industries, we offer contract-to-hire solutions for projects requiring immediate resource allocation, while also supporting your future growth. Our services help you assess the risks of direct hiring and evaluate whether a candidate is the right fit during the initial contract period.",
      link: routes.services.businessintelligence,
    },
    {
      img: products2codeing,
      title: "Permanent Staffing",
      icon: iconhome2,
      content:
        "We dedicate time to understanding your business needs, industry skill sets, workforce market, and other pertinent details about the position to ensure we present the right candidate. Our recruitment experts utilize advanced search processes to identify, screen, and qualify candidates effectively. By streamlining the hiring process, we save you time and costs, ensuring you find talent that not only meets the job description but also aligns with your company culture, values, and long-term goals.",
      link: routes.services.mobileappdev,
    },
    {
      img: products3cloud,
      title: "Supplier Optimization",
      icon: iconhome3,
      content:
        "With vast experience and a global footprint, we partner with multi-billion-dollar clients across the USA, Canada and India to achieve cost savings and minimize disruptions. We focus on optimizing tail spend, reducing supplier layers, and excelling in contract negotiation, compliance, and governance. Our Preferred Partner program, bolstered by governance, financial resources, and a legal team, promotes diversity spending and facilitates smooth geographical expansion. As a certified MBE, Briozon ensures compliance and acts as a trusted intermediary between you and your vendors",
      link: routes.services.cloudcomputing,
    },
    {
      img: products4quality,
      title: "Recruit, Develop, and Implement",
      icon: iconhome4,
      content:
        "We provide a full suite of HTD solutions to assist you in sourcing, training, and deploying talent, whether you’re a small business or a large corporation. Our customized programs, which include accent-neutral, technical, and cultural fit training, create a seamless talent pipeline from entry-level to specialized positions. By leveraging access to diverse markets and collaborating with top institutions and industry leaders, we equip your workforce with advanced skills. We manage everything from background checks to payroll, ensuring a smooth experience while promoting diversity and facilitating your global expansion.",
      link: routes.products.customcrm,
    },
    {
      img: products2codeing,
      title: "Contract Talent Acquisition",
      icon: iconhome2,
      content:
        "Our recruiting specialists have elevated the screening and hiring process for short-term projects to a new standard of efficiency. With our contract services, you can seamlessly fulfill temporary staffing needs across a diverse array of industries. Our dedicated team works in close partnership with you to ensure that your staffing requirements are expertly addressed for upcoming projects and seasonal demands, empowering you to maintain optimal staff levels through strategic contract hiring.",
      link: routes.services.mobileappdev,
    },
  ];
};
const financeSliderData = [
  {
    img: products1Ai,
    title: "AI & ML Implementation",
    icon: iconhome1,
    content:
      "AI and ML implementation empowers businesses with personalized marketing insights, leveraging customer data for targeted campaigns. Predictive maintenance anticipates equipment failures, reducing downtime and optimizing operational efficiency,and enhance productivity, resulting in increased efficiency and profitability. ",
  },
  {
    img: products2codeing,
    title: "Software Development",
    icon: iconhome2,
    content:
      "Involves creating unique software solutions tailored to the specific needs of a business or organization, allowing for greater flexibility, scalability, and functionality than off-the-shelf software. It can improve business processes, automate tasks, and enhance productivity, resulting in increased efficiency and profitability.",
  },
  {
    img: products3cloud,
    title: "Cloud Specialization",
    icon: iconhome3,
    content:
      "We focusing on a specific area or technology within the broader field of cloud computing. This can include specializing in a particular cloud platform that fits on customer needs, such as AWS, Azure, or GCP, or in a specific area of cloud computing, such as cloud security, cloud migration, cloud architecture, or cloud operations.",
  },
  {
    img: products4quality,
    title: "Quality Product",
    icon: iconhome4,
    content:
      "We provide quality software product is one that not only meets the functional requirements of its users, but also exceeds their expectations in terms of its performance, usability, and security. It should be reliable, efficient, and user-friendly, while also being robust and secure to protect users' data and privacy.",
  },
];
const retailSliderData = [
  {
    img: products1Ai,
    title: "AI & ML Implementation",
    icon: iconhome1,
    content:
      "AI and ML implementation empowers businesses with personalized marketing insights, leveraging customer data for targeted campaigns. Predictive maintenance anticipates equipment failures, reducing downtime and optimizing operational efficiency,and enhance productivity, resulting in increased efficiency and profitability. ",
  },
  {
    img: products2codeing,
    title: "Software Development",
    icon: iconhome2,
    content:
      "Involves creating unique software solutions tailored to the specific needs of a business or organization, allowing for greater flexibility, scalability, and functionality than off-the-shelf software. It can improve business processes, automate tasks, and enhance productivity, resulting in increased efficiency and profitability.",
  },
  {
    img: products3cloud,
    title: "Cloud Specialization",
    icon: iconhome3,
    content:
      "We focusing on a specific area or technology within the broader field of cloud computing. This can include specializing in a particular cloud platform that fits on customer needs, such as AWS, Azure, or GCP, or in a specific area of cloud computing, such as cloud security, cloud migration, cloud architecture, or cloud operations.",
  },
  {
    img: products4quality,
    title: "Quality Product",
    icon: iconhome4,
    content:
      "We provide quality software product is one that not only meets the functional requirements of its users, but also exceeds their expectations in terms of its performance, usability, and security. It should be reliable, efficient, and user-friendly, while also being robust and secure to protect users' data and privacy.",
  },
];

const talentManagementData_3 = [
  {
    imageUrl: tm1,
    title: "Contract to Hire",
    content:
      "Contract-to-hire lets you quickly add staff with the option to transition them to full-time. We provide flexible solutions across industries, helping you assess candidates before making a commitment.",
  },
  {
    imageUrl: tm2,
    title: "Permanent Staffing",
    content:
      "We tailor our search to your needs, using advanced screening to streamline hiring and find the perfect candidate.",
  },
  {
    imageUrl: tm3,
    title: "Supplier Optimization",
    content:
      "With global expertise, Briozon reduces costs, streamlines suppliers, ensures compliance, and supports diversity as a certified MBE.",
  },
  {
    imageUrl: tm4,
    title: "Recruit, Develop, and Implement",
    content:
      "We offer HTD solutions for sourcing, training, and deploying talent, ensuring a skilled workforce. Our services streamline compliance, diversity, and global expansion.",
  },
  {
    imageUrl: tm5,
    title: "Contract Talent Acquisition",
    content:
      "Briozon provides cost-effective contract staffing solutions, optimizing talent acquisition and compliance across global markets. We ensure seamless integration of skilled professionals for short-term and long-term projects.",
  },
  {
    imageUrl: tm3,
    title: "Resource Allocation Strategy",
    content:
      "Our Resource Allocation Strategy team ensures the right talent is deployed to optimize project outcomes. We streamline staffing to align with your business goals, maximizing efficiency and reducing costs.",
  },
];

const ourServicesHomeData = [
  {
    imageUrl: cad1,
    title: "Custom Application Development",
    content:
      "We are a team of experienced professionals in the software development and IT staffing industry. We are passionate about creating innovative solutions for our clients and providing exceptional talent for their technology needs.",
    navlink: "services.customappdev",
  },
  {
    imageUrl: qa1,
    title: "Quality Engineering & Assurance",
    content:
      "At Briozon, the quality of products serves as one of the critical KPI before any production deployment. Briozon is continuously striving towards new technologies and approaches to test any type of product be it web or desktop applications. ",
    navlink: "services.qualityassurance",
  },
  {
    imageUrl: manageit,
    title: "Managed IT Services",
    content:
      "At our company, we offer Managed IT services to help businesses manage and optimize their IT operations. Our team of experts provides end-to-end services, from infrastructure management and network monitoring to helpdesk support and cloud management. ",
    navlink: "services.managedITservices",
  },
  {
    imageUrl: itConsulting,
    title: "IT consulting & Strategy",
    content:
      "We are a leading provider of IT consulting and strategy services, helping businesses of all sizes to achieve their digital transformation goals. Our team of experts works closely with clients to understand their unique business requirements.",
    navlink: "services.itconsulting",
  },
  {
    imageUrl: digi,
    title: "DigitalMarketing & Interaction",
    content:
      "We offer a full range of digital marketing services to help businesses build their brand, reach their target audience, and drive growth. Our services include search engine optimization (SEO), pay-per-click (PPC) advertising, social media marketing, ect.",
    navlink: "services.digitalmarketinginteraction",
  },
  {
    imageUrl: crm,
    title: "Customer Relationship Management",
    content:
      "Our certified consultants can help in developing the roadmap to CRM success. A CRM gives organizations the tools to streamline their operations, keep track of customer interactions, and unify data or team silos into a single source of truth.",
    navlink: "services.crm",
  },
];

const jobPostings = [
  {
    jobId: "BZ2680",
    title: "Full Stack Developer",
    location: "Texas, USA",
    jobCategory: ["Senior-level", "4+ Years", "Full-Time"],
    createdDate: 12,
    skills: ["React JS", "Vue Js", "Python", "MongoDB"],
    additionalSkills: ["GraphQL", "REST APIs", "Unit Testing"],
    description:
      "We believe that design (and you) will be critical to the company's success. You will work with our founders and our early customers to help define and build our product functionality.",
  },
  {
    jobId: "BZ2681",
    title: "Frontend Developer",
    location: "San Francisco, USA",
    jobCategory: ["Mid-level", "2-4 Years", "Full-Time"],
    createdDate: 3,
    skills: ["React JS", "TypeScript", "HTML5", "CSS3"],
    additionalSkills: [
      "Web Performance Optimization",
      "SEO",
      "Cross-Browser Compatibility",
    ],
    description:
      "Join our dynamic team to create intuitive and visually stunning web applications. You'll collaborate with designers and backend developers to deliver seamless user experiences.",
  },
  {
    jobId: "BZ2682",
    title: "Backend Engineer",
    location: "Remote",
    jobCategory: ["Junior-level", "1-2 Years", "Part-Time"],
    createdDate: 9,
    skills: ["Node.js", "Express", "MongoDB", "PostgreSQL"],
    additionalSkills: ["API Security", "Serverless Functions", "Microservices"],
    description:
      "We are looking for a backend engineer to develop and maintain robust APIs. You'll play a critical role in ensuring the reliability and scalability of our server-side systems.",
  },
  {
    jobId: "BZ2683",
    title: "Data Scientist",
    location: "New York, USA",
    jobCategory: ["Senior-level", "5+ Years", "Full-Time"],
    createdDate: 15,
    skills: ["Python", "TensorFlow", "SQL", "Big Data"],
    additionalSkills: [
      "Data Visualization",
      "ETL Processes",
      "Machine Learning Models",
    ],
    description:
      "We are seeking a data scientist to derive actionable insights from large datasets. You'll work closely with cross-functional teams to influence business decisions with data-driven strategies.",
  },
  {
    jobId: "BZ2684",
    title: "DevOps Engineer",
    location: "London, UK",
    jobCategory: ["Mid-level", "3-5 Years", "Full-Time"],
    createdDate: 4,
    skills: ["Docker", "Kubernetes", "AWS", "CI/CD"],
    additionalSkills: [
      "Monitoring Tools",
      "Infrastructure as Code",
      "Automation Scripts",
    ],
    description:
      "As a DevOps Engineer, you'll automate and streamline our operations and processes. You'll help maintain development tools and deploy systems in a reliable and scalable manner.",
  },
  {
    jobId: "BZ2685",
    title: "Mobile App Developer",
    location: "Seattle, USA",
    jobCategory: ["Mid-level", "3+ Years", "Full-Time"],
    createdDate: 7,
    skills: ["Flutter", "React Native", "iOS", "Android"],
    additionalSkills: [
      "Mobile UI/UX",
      "App Store Optimization",
      "Push Notifications",
    ],
    description:
      "We are looking for a Mobile App Developer to build innovative and scalable mobile applications for our global user base.",
  },
  {
    jobId: "BZ2686",
    title: "UI/UX Designer",
    location: "Remote",
    jobCategory: ["Entry-level", "0-2 Years", "Full-Time"],
    createdDate: 1,
    skills: ["Figma", "Adobe XD", "Sketch", "User Research"],
    additionalSkills: ["Prototyping", "Wireframing", "Accessibility Standards"],
    description:
      "As a UI/UX Designer, you will craft engaging user experiences and work closely with our development team to implement them seamlessly.",
  },
  {
    jobId: "BZ2687",
    title: "Cloud Engineer",
    location: "Austin, USA",
    jobCategory: ["Senior-level", "4+ Years", "Full-Time"],
    createdDate: 11,
    skills: ["Azure", "AWS", "GCP", "Terraform"],
    additionalSkills: [
      "Cloud Security",
      "Cost Optimization",
      "Cloud Migration",
    ],
    description:
      "We're seeking a Cloud Engineer to optimize and manage our cloud infrastructure.",
  },
  {
    jobId: "BZ2688",
    title: "Machine Learning Engineer",
    location: "Boston, USA",
    jobCategory: ["Senior-level", "5+ Years", "Full-Time"],
    createdDate: 2,
    skills: ["Python", "PyTorch", "TensorFlow", "Data Modeling"],
    additionalSkills: [
      "Deep Learning",
      "Natural Language Processing",
      "Recommendation Systems",
    ],
    description:
      "We're hiring a Machine Learning Engineer to design, develop, and optimize ML models for our cutting-edge applications.",
  },
  {
    jobId: "BZ2689",
    title: "Cybersecurity Analyst",
    location: "Washington, USA",
    jobCategory: ["Mid-level", "3-5 Years", "Full-Time"],
    createdDate: 8,
    skills: [
      "Network Security",
      "Penetration Testing",
      "SIEM",
      "Incident Response",
    ],
    additionalSkills: [
      "Threat Intelligence",
      "Cryptography",
      "Firewall Management",
    ],
    description:
      "Join our security team as a Cybersecurity Analyst to identify and mitigate vulnerabilities and ensure the safety of our systems.",
  },
  {
    jobId: "BZ2690",
    title: "Game Developer",
    location: "Los Angeles, USA",
    jobCategory: ["Mid-level", "3-5 Years", "Full-Time"],
    createdDate: 5,
    skills: ["Unity", "C#", "Game Physics", "3D Modeling"],
    additionalSkills: [
      "VR/AR Development",
      "Game Optimization",
      "Storyboarding",
    ],
    description:
      "We are seeking a creative Game Developer to build immersive and engaging gaming experiences using state-of-the-art technology.",
  },
];

const crmData_4 = [
  {
    title: "Solution Design",
    icon: trophy,
  },
  {
    title: "Implementation Services",
    icon: soft_ver,
  },
  {
    title: "Testing & Optimization",
    icon: test_off,
  },
  {
    title: "Handover & Hypercare",
    icon: years_test,
  },
  {
    title: "Managed Services",
    icon: feildService,
  },
  {
    title: "Maintenance & Support",
    icon: support,
  },
];

export const FastATSService = [
  {
    title: "Automated Screening",
    icon: trophy,
  },
  {
    title: "Effortless Scheduling",
    icon: soft_ver,
  },
  {
    title: "Real-Time Tracking",
    icon: test_off,
  },
  {
    title: "Team Collaboration",
    icon: years_test,
  },
  {
    title: "Seamless Integration",
    icon: feildService,
  },
  {
    title: "Customizable Workflows",
    icon: support,
  },
];

export const DigitalToolService = [
  {
    title: "Custom Integration",
    icon: trophy,
  },
  {
    title: "Data Analytics",
    icon: soft_ver,
  },
  {
    title: "Automation Solutions",
    icon: test_off,
  },
  {
    title: "Collaboration Tools",
    icon: years_test,
  },
  {
    title: "Scalable Solutions",
    icon: feildService,
  },
  {
    title: "Expert Support",
    icon: support,
  },
];


const crmSalesData = [
  {
    title: "Certified Professionals",
    subText: "150",
    icon: cubeimg,
    description:
      "Salesforce solutions with their highly-skilled, certified, & experienced developers with over 150 Certified Professionals",
  },
  {
    title: "Partner Rating",
    subText: "4.5 +",
    icon: diamondimg,
    description:
      "10+ AppExchange Reviews and 4.5+ partner ratings Briozon has established itself in the core Salesforce niche",
  },
];

const qatoolsData = [
  { title: "Maven-logo", image: maven },
  { title: "Jenkins-logo", image: jenkins },
  { title: "TestNG-logo", image: testNG },
  { title: "Jmeter-logo", image: jmeter },
  { title: "Postman-logo", image: postman },
];
const crmSalesforceData = [
  { title: "Marketing", image: marketing },
  { title: "Analytics Einstein", image: analytics },
  { title: "Commerce", image: commerce },
  { title: "Field Service Lightning ", image: feildService },
  { title: "Platform", image: platform },
  { title: "Communities", image: communities },
  { title: "Service", image: serviceimg },
  
  { title: "Sales", image: salesImg },
];

export {
  topSlideData,
  chooseUsData,
  talentManagementData_1,
  talentManagementData_2,
  serviceCADData_1,
  serviceCADData_2,
  financeSliderData,
  servicecloudData_1,
  servicecyberData_1,
  retailSliderData,
  talentManagementData_3,
  talentMgmtData3,
  productsSliderHomeData,
  ourServicesHomeData,
  serviceCADData_3,
  servicesQualityAData_4,
  jobPostings,
  qatoolsData,
  crmSalesforceData,
  crmSalesData,
  crmData_4,
};
